const CONFIG = global.blokableConfig
global.blokableConfig = undefined

export default CONFIG
